import { Outlet, useLocation } from 'react-router-dom'
import authImageLogin from '@assets/images/image_01.png'
import authImageLoginPhone from '@assets/images/image_02.png'
import authImageRegister from '@assets/images/image_03.png'
import { useState, useEffect } from 'react'
import Header from '@components/common/Header'

function AuthLayout() {
  const location = useLocation()
  const isRegisterPage = location.pathname.includes('/register')
  const isForgotPasswordPage = location.pathname.includes('/forgot-password')
  const isPhoneVerificationPage = location.pathname.includes('/phone-verification')
  const [loginMethod, setLoginMethod] = useState('email')
  
  useEffect(() => {
    const handleStorageChange = () => {
      const method = localStorage.getItem('loginMethod') || 'email'
      setLoginMethod(method)
    }
    
    handleStorageChange()
    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('loginMethodChange', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('loginMethodChange', handleStorageChange)
    }
  }, [])
  
  let authImage = authImageLogin
  if (isRegisterPage) {
    authImage = authImageRegister
  } else if (isPhoneVerificationPage) {
    authImage = authImageLoginPhone
  } else if (isForgotPasswordPage) {
    authImage = authImageLogin
  } else if (loginMethod === 'phone') {
    authImage = authImageLoginPhone
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-1">
      {/* Partie gauche avec image en plein écran */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-pink-200 via-pink-300 to-orange-200 items-center justify-center relative overflow-hidden">
        <img 
          src={authImage} 
          alt="LIGDI Authentication" 
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Partie droite avec formulaire */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
      </div>
    </div>
  )
}

export default AuthLayout
